import { spaceOf } from "@/lib/spaces";

export const SpaceAvatar = ({ space, size = "sm" }) => {
  const s = spaceOf(space);
  const dim = size === "lg" ? "h-9 w-9 text-sm" : "h-6 w-6 text-[11px]";
  return (
    <span
      title={s.name}
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-display font-bold ${dim}`}
      style={{ background: `${s.color}22`, color: s.color, boxShadow: `inset 0 0 0 1px ${s.color}55` }}
    >
      {s.key === "all" ? "A" : s.emoji || s.name[0]}
    </span>
  );
};
